module.exports = __webpack_public_path__ + "media/MESSAGE.40b860f6.mp3";